import './CodeBreadcrumb.css'

// The Library location bar. Segments are: "Library" (index -1) followed by the
// drill trail (index 0..n). Clicking a segment navigates back to that level; the
// last segment is the current position and isn't clickable. Deep paths collapse
// the middle to an ellipsis (full path shown on hover) so they never overflow the
// narrow nav column.
function CodeBreadcrumb({ rootLabel = 'Library', trail = [], onNavigate }) {
  const segments = [{ label: rootLabel, index: -1 }, ...trail.map((it, i) => ({ label: it.label, index: i }))]

  // Keep the first (Library) and the last two; collapse anything between.
  let shown = segments
  let hidden = []
  if (segments.length > 4) {
    hidden = segments.slice(1, segments.length - 2)
    shown = [segments[0], { ellipsis: true }, ...segments.slice(segments.length - 2)]
  }

  const lastIndex = segments[segments.length - 1].index

  return (
    <div className="code-crumb">
      {shown.map((seg, i) => {
        if (seg.ellipsis) {
          return (
            <span key="ellipsis" className="code-crumb-sep-group">
              <span className="code-crumb-sep">/</span>
              <span className="code-crumb-more" title={hidden.map((h) => h.label).join(' / ')}>
                …
              </span>
            </span>
          )
        }
        const isCurrent = seg.index === lastIndex
        return (
          <span key={seg.index} className="code-crumb-sep-group">
            {i > 0 && <span className="code-crumb-sep">/</span>}
            {isCurrent ? (
              <span className="code-crumb-current" title={seg.label}>
                {seg.label}
              </span>
            ) : (
              <button
                type="button"
                className="code-crumb-link"
                title={seg.label}
                onClick={() => onNavigate?.(seg.index)}
              >
                {seg.label}
              </button>
            )}
          </span>
        )
      })}
    </div>
  )
}

export default CodeBreadcrumb
